import type { Customer } from "@/api/token/customer";
import { Button, Item, ItemActions, ItemContent, ItemDescription, ItemTitle } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

function CustomerItem({
  customer,
  onSelect,
}: {
  customer: Customer;
  onSelect: (customerId: number) => void;
}) {
  const { t } = useTranslation();

  return (
    <Item
      variant="default"
      className="cursor-pointer border-l-6 border-l-primary bg-white hover:border-l-accent hover:bg-neutral-50"
      onClick={() => onSelect(customer.customerId)}
    >
      <ItemContent>
        <ItemTitle>{customer.name}</ItemTitle>
        <ItemDescription>
          {t("customers.list.messages.customer_id", {
            customerId: customer.customerId,
          })}
        </ItemDescription>
      </ItemContent>
      <ItemActions>
        <Button variant="secondary">
          {t("common.actions.global.select")}
        </Button>
      </ItemActions>
    </Item>
  );
}

export default CustomerItem;
